// The client's log: the console by default; the bots and tests can quieten it or send it elsewhere.
export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const order: Record<LogLevel, number> = { debug: 0, info: 1, warn: 2, error: 3 };

export const log = {
  level: 'info' as LogLevel,
  sink: (level: LogLevel, text: string) => {
    const out = level === 'error' ? console.error : level === 'warn' ? console.warn : console.log;
    out(`[${level}] ${text}`);
  },
  debug(text: string) { this.write('debug', text); },
  info(text: string) { this.write('info', text); },
  warn(text: string) { this.write('warn', text); },
  error(text: string, e?: unknown) { this.write('error', e ? `${text}: ${e instanceof Error ? e.message : String(e)}` : text); },
  write(level: LogLevel, text: string) { if (order[level] >= order[this.level]) this.sink(level, text); },
};
